import { render, staticRenderFns } from "./labelDespatchBadge.vue?vue&type=template&id=79e14364&"
import script from "./labelDespatchBadge.vue?vue&type=script&lang=js&"
export * from "./labelDespatchBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports